import clsx from 'clsx';
import { Button } from '../button';
import { Icon } from '../icon';

import styles from './banner.module.scss';

export const Banner = (props: BannerProps) => {
  const { type, title, message, onClose, action } = props;

  const iconType = iconTypes[type];

  return (
    <ul className={clsx(styles.banner, styles[`t-${type}`])}>
      <li>
        <Icon data-testid="icon" type={iconType} size={20} className={styles.leadingIcon} />
        <span className="ellipsis-text">{title}</span>
        {!!onClose && <Icon type="cancel-01" data-testid="icon-close" size={16} onClick={onClose} className={styles.closeIcon} />}
      </li>
      <li className={clsx(styles.message, 'ellipsis-text')}>{message}</li>
      {!!action && (
        <li className={styles.action}>
          <Button size="small" color="dark" cornerRadius="rounded" onClick={action.onClick} disabled={action.disabled}>
            {action.label}
          </Button>
        </li>
      )}
    </ul>
  );
};

const iconTypes: Record<BannerProps['type'], string> = {
  danger: 'alert-02-solid',
  hint: 'information-diamond',
  neutral: 'information-circle-solid',
};

export interface BannerProps {
  title: string;
  message: string;
  onClose?: () => void;
  type: 'danger' | 'hint' | 'neutral';
  action?: { label: string; onClick: () => void; disabled?: boolean };
}
